// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#mw #sharable-dashboard-editor.sharable-dashboard main {
}

#mw #sharable-dashboard-editor.sharable-dashboard main > div {
    justify-content: center;
    width: 100%;
    height: 95%;
    background: #FFF;
    margin: 16px;
    box-shadow: 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12), 0 3px 5px -1px rgba(0,0,0,.2);
}

#mw #sharable-dashboard-flexi-modal.mw-flexi-modal>md-dialog-content {
    background: #FFF;
}

#mw #sharable-dashboard__preview__outter-container,
#mw #sharable-dashboard__loading__outter-container {
    background: rgb(246, 246, 246);
}

#mw #sharable-dashboard__loading__header,
#mw #sharable-dashboard__loading__ready-header {
    font-family: "Helvetica","Arial",sans-serif;
    font-size: 24px;
    font-weight: 400;
    line-height: 20px;
}

#mw .sharable-dashboard__loading__text {
    font-family: "Helvetica","Arial",sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
}
#mw .sharable-dashboard__loading__text a {
    color: rgb(0, 0, 0, 0.87);
}

#mw .sharable-dashboard__loading__spacer {
    height: 24px;
}

#mw #sharable-dashboard__loading__dropplet-container,
#mw #sharable-dashboard__loading__button-container {
    position: relative;
    height: 75px;
}

#mw #sharable-dashboard__loading__dropplet-container .mw-loader {
    position: absolute !important;
    left: -36px;
}

#mw #sharable-dashboard-editor.sharable-dashboard .pr-report__slide__inner-full {
    padding: 0 24px;
    margin-top: 0;
    width: 80%;
    height: 100%;
}

#mw #sharable-dashboard-editor.sharable-dashboard .pr-report__slide__inner-full .height-container {
    height: 80%;
}

#mw #sharable-dashboard-editor.sharable-dashboard main .main-section {
    height: 80%;
}

#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .sharable-dashboard_main-graph__legend,
#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .media-exposure__graph,
#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .top-publications__volume__graph-container,
#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .tonality__graph,
#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .pr-report__geo-presence__bottom-section__row,
#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .geo-presence__graph-container,
#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .geo-presence-country__graph-container,
#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .content-stream-container {
    opacity: 0.3;
}

#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .sharable-dashboard__summary-container {
    border-bottom: none;
}

#mw #sharable-dashboard-editor .sharable-dashboard {
    height: 100%;
}

#mw #sharable-dashboard-nav-panel {
    background: #FFF;
    border-right: 1px solid rgb(221, 221, 221);
    overflow: scroll;
    position: fixed;
    left: 0%;
    top: 64px;
    z-index: 1;
    width: 224px;
    height: 85%;
    /* padding-bottom: 156px; */
}

#mw .sharable-dashboard-nav-panel__item {
    height: 100px;
    padding: 16px 0 16px 8px;
}
#mw .sharable-dashboard-nav-panel__item.active {
    background: rgb(232, 232, 232);
}

#mw .sharable-dashboard-nav-panel__label {
    display: inline-block;
    font-weight: bold;
    width: 20px;
    margin-right: 12px;
    vertical-align: top;
    text-align: right;
}

#mw .sharable-dashboard-nav-panel__thumbnail {
    display: inline-block;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
}

#mw .sharable-dashboard-nav-panel__thumbnail,
#mw .sharable-dashboard-nav-panel__thumbnail img {
    width: 140px;
    outline: none;
}

#mw .sharable-dashboard-nav-panel__title {
    width: 89%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
    padding: 8px;
    background: #fff;
    text-decoration: none;
    text-align: center;
    color: rgba(0, 0, 0, 0.5);
}

#mw .sharable-dashboard-nav-panel__item.active .sharable-dashboard-nav-panel__label,
#mw .sharable-dashboard-nav-panel__item.active .sharable-dashboard-nav-panel__title {
    color: rgb(40, 187, 187);
}

#mw mw-pr-insight-sharable-dashboard-report-builder-preview {
    height: 100%;
}

#mw #sharable-dashboard-editor {
    margin-left: 224px;
    height: 100%;
}

#mw .pr-report__main__title-container md-input-container {
    width: 750px;
    margin-top: 0;
    padding-top: 0;
    padding-left: 0;
}
#mw .sharable-dashboard__summary-container md-input-container {
    width: 100%;
    margin-top: 0;
    padding-left: 0;
    padding-top: 0;
}
#mw .sharable-dashboard__summary-container md-input-container textarea {
    line-height: 20px;
    height: 42px !important;
    padding: 0;
}
#mw .pr-report__cover-slide__main-container {
    height: 100%;
}
#mw .pr-report__main__title-container input, #mw .mdl-typography--footer__cover-title input {
    font-size: 32px;
    height: 42px;
    text-align: left;
}
#mw .footer__subtitle__input {
    font-size: 24px;
    width: 98%;
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 0;
    padding-bottom: 0;
}

#mw .divider-slide-container .sharable-dashboard__body md-input-container {
    width: 100%;
}

#mw #sharable-dashboard__action-buttons {
    width: 100%;
    text-align: right;
    position: fixed;
    top: 102px;
    left: 50%;
    margin-left: -54%;
    z-index: 2;
}

#mw #sharable-dashboard__action-buttons .md-button {
    margin-bottom: -48px;
}

#mw #sharable-dashboard__action-buttons .md-button {
    min-width: 0;
}

#mw #share-dashboard__add-widget-menu .mw-menu-item__single-select-icon {
    display: none;
}

#mw .summary-slide-container__main-content md-input-container {
    width: 100%;
    height: 100%;
    padding-left: 0;
}

/* fixed position elements don't seem to play nicely with transitions in Firefox.  So, disable them. */
#mw .share-dashboard__disable-transitions {
    /* -webkit-transition: none;
    transition: none;
    -webkit-transform: none;
    transform: none; */
}

.no-scroll {
    overflow: hidden;
}

#mw .sharable-dashboard__summary-text-container.hide-me {
    visibility: collapse;
}

#mw .sharable-dashboard__summary-text-container.hide-me .should-clean-up {
    visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./public/js/components/builder/style.css"],"names":[],"mappings":";AACA;AACA;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,qGAAqG;AACzG;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,2CAA2C;IAC3C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,aAAa;IACb,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;;;;;;;;IAQI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;IAC1C,gBAAgB;IAChB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,yHAAyH;AAC7H;;AAEA;;IAEI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,eAAe;AACnB;AACA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA,sGAAsG;AACtG;IACI;;;sBAGkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["\n#mw #sharable-dashboard-editor.sharable-dashboard main {\n}\n\n#mw #sharable-dashboard-editor.sharable-dashboard main > div {\n    justify-content: center;\n    width: 100%;\n    height: 95%;\n    background: #FFF;\n    margin: 16px;\n    box-shadow: 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12), 0 3px 5px -1px rgba(0,0,0,.2);\n}\n\n#mw #sharable-dashboard-flexi-modal.mw-flexi-modal>md-dialog-content {\n    background: #FFF;\n}\n\n#mw #sharable-dashboard__preview__outter-container,\n#mw #sharable-dashboard__loading__outter-container {\n    background: rgb(246, 246, 246);\n}\n\n#mw #sharable-dashboard__loading__header,\n#mw #sharable-dashboard__loading__ready-header {\n    font-family: \"Helvetica\",\"Arial\",sans-serif;\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 20px;\n}\n\n#mw .sharable-dashboard__loading__text {\n    font-family: \"Helvetica\",\"Arial\",sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n}\n#mw .sharable-dashboard__loading__text a {\n    color: rgb(0, 0, 0, 0.87);\n}\n\n#mw .sharable-dashboard__loading__spacer {\n    height: 24px;\n}\n\n#mw #sharable-dashboard__loading__dropplet-container,\n#mw #sharable-dashboard__loading__button-container {\n    position: relative;\n    height: 75px;\n}\n\n#mw #sharable-dashboard__loading__dropplet-container .mw-loader {\n    position: absolute !important;\n    left: -36px;\n}\n\n#mw #sharable-dashboard-editor.sharable-dashboard .pr-report__slide__inner-full {\n    padding: 0 24px;\n    margin-top: 0;\n    width: 80%;\n    height: 100%;\n}\n\n#mw #sharable-dashboard-editor.sharable-dashboard .pr-report__slide__inner-full .height-container {\n    height: 80%;\n}\n\n#mw #sharable-dashboard-editor.sharable-dashboard main .main-section {\n    height: 80%;\n}\n\n#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .sharable-dashboard_main-graph__legend,\n#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .media-exposure__graph,\n#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .top-publications__volume__graph-container,\n#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .tonality__graph,\n#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .pr-report__geo-presence__bottom-section__row,\n#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .geo-presence__graph-container,\n#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .geo-presence-country__graph-container,\n#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .content-stream-container {\n    opacity: 0.3;\n}\n\n#mw #sharable-dashboard-editor.sharable-dashboard.is-editing .sharable-dashboard__summary-container {\n    border-bottom: none;\n}\n\n#mw #sharable-dashboard-editor .sharable-dashboard {\n    height: 100%;\n}\n\n#mw #sharable-dashboard-nav-panel {\n    background: #FFF;\n    border-right: 1px solid rgb(221, 221, 221);\n    overflow: scroll;\n    position: fixed;\n    left: 0%;\n    top: 64px;\n    z-index: 1;\n    width: 224px;\n    height: 85%;\n    /* padding-bottom: 156px; */\n}\n\n#mw .sharable-dashboard-nav-panel__item {\n    height: 100px;\n    padding: 16px 0 16px 8px;\n}\n#mw .sharable-dashboard-nav-panel__item.active {\n    background: rgb(232, 232, 232);\n}\n\n#mw .sharable-dashboard-nav-panel__label {\n    display: inline-block;\n    font-weight: bold;\n    width: 20px;\n    margin-right: 12px;\n    vertical-align: top;\n    text-align: right;\n}\n\n#mw .sharable-dashboard-nav-panel__thumbnail {\n    display: inline-block;\n    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);\n}\n\n#mw .sharable-dashboard-nav-panel__thumbnail,\n#mw .sharable-dashboard-nav-panel__thumbnail img {\n    width: 140px;\n    outline: none;\n}\n\n#mw .sharable-dashboard-nav-panel__title {\n    width: 89%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 16px;\n    padding: 8px;\n    background: #fff;\n    text-decoration: none;\n    text-align: center;\n    color: rgba(0, 0, 0, 0.5);\n}\n\n#mw .sharable-dashboard-nav-panel__item.active .sharable-dashboard-nav-panel__label,\n#mw .sharable-dashboard-nav-panel__item.active .sharable-dashboard-nav-panel__title {\n    color: rgb(40, 187, 187);\n}\n\n#mw mw-pr-insight-sharable-dashboard-report-builder-preview {\n    height: 100%;\n}\n\n#mw #sharable-dashboard-editor {\n    margin-left: 224px;\n    height: 100%;\n}\n\n#mw .pr-report__main__title-container md-input-container {\n    width: 750px;\n    margin-top: 0;\n    padding-top: 0;\n    padding-left: 0;\n}\n#mw .sharable-dashboard__summary-container md-input-container {\n    width: 100%;\n    margin-top: 0;\n    padding-left: 0;\n    padding-top: 0;\n}\n#mw .sharable-dashboard__summary-container md-input-container textarea {\n    line-height: 20px;\n    height: 42px !important;\n    padding: 0;\n}\n#mw .pr-report__cover-slide__main-container {\n    height: 100%;\n}\n#mw .pr-report__main__title-container input, #mw .mdl-typography--footer__cover-title input {\n    font-size: 32px;\n    height: 42px;\n    text-align: left;\n}\n#mw .footer__subtitle__input {\n    font-size: 24px;\n    width: 98%;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0;\n    padding-bottom: 0;\n}\n\n#mw .divider-slide-container .sharable-dashboard__body md-input-container {\n    width: 100%;\n}\n\n#mw #sharable-dashboard__action-buttons {\n    width: 100%;\n    text-align: right;\n    position: fixed;\n    top: 102px;\n    left: 50%;\n    margin-left: -54%;\n    z-index: 2;\n}\n\n#mw #sharable-dashboard__action-buttons .md-button {\n    margin-bottom: -48px;\n}\n\n#mw #sharable-dashboard__action-buttons .md-button {\n    min-width: 0;\n}\n\n#mw #share-dashboard__add-widget-menu .mw-menu-item__single-select-icon {\n    display: none;\n}\n\n#mw .summary-slide-container__main-content md-input-container {\n    width: 100%;\n    height: 100%;\n    padding-left: 0;\n}\n\n/* fixed position elements don't seem to play nicely with transitions in Firefox.  So, disable them. */\n#mw .share-dashboard__disable-transitions {\n    /* -webkit-transition: none;\n    transition: none;\n    -webkit-transform: none;\n    transform: none; */\n}\n\n.no-scroll {\n    overflow: hidden;\n}\n\n#mw .sharable-dashboard__summary-text-container.hide-me {\n    visibility: collapse;\n}\n\n#mw .sharable-dashboard__summary-text-container.hide-me .should-clean-up {\n    visibility: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
